import {Injectable} from '@angular/core';
import {FilesEntity} from "../entity/files.entity";
import {ApiFilesRepository} from "../services/api/files/api.files.repository";


@Injectable({
    providedIn: 'root'
})
export class Files extends FilesEntity {

    constructor(
        private apiFilesRepository?: ApiFilesRepository
    ) {
        super();
    }


    public static build(data: {}) {
        const files = new Files();
        for (const propiedad in data) {
            // @ts-ignore
            files[propiedad] = data[propiedad];
        }
        return files;
    }

    public async getFileFormat(obj: any): Promise<any> {
        // @ts-ignore
        return await this.apiFilesRepository.getFileFormat(obj);
    }

    public async getTypeFilesBooking(): Promise<any> {
        // @ts-ignore
        return await this.apiFilesRepository.getTypeFilesBooking();
    }







}
